import type { Component } from 'vue'
import { HeartIcon, ShoppingBag01Icon, User01Icon } from '@gohighlevel/ghl-icons/24/outline'

export interface CacTab {
  id: string
  labelKey: string
  route: string
  order: number
  icon: Component
}

export const cacTabs: CacTab[] = [
  { id: 'orders', labelKey: 'nav.orders', route: '/orders', order: 10, icon: ShoppingBag01Icon },
  { id: 'wishlist', labelKey: 'nav.wishlist', route: '/wishlist', order: 20, icon: HeartIcon },
  { id: 'profile', labelKey: 'nav.profile', route: '/profile', order: 30, icon: User01Icon },
]

export const orderedCacTabs = (): CacTab[] => [...cacTabs].sort((a, b) => a.order - b.order)
